export interface NotificationChannelPrefs {
  email: boolean;
  push: boolean;
}

export type NotificationPreferencesMatrix = Record<
  string,
  NotificationChannelPrefs
>;

export const NOTIFICATION_PREFERENCES_ORG_DEFAULTS_KEY =
  'notification_preferences_defaults';

export const DUNA_EVENT_NOTIFICATION_PREFERENCE_ROWS: ReadonlyArray<{
  key: string;
  label: string;
}> = [
  { key: 'user_added_to_event', label: 'Tilmelding til event' },
  { key: 'user_added_to_waitlist', label: 'Tilmelding til venteliste' },
  {
    key: 'event_status_changed',
    label: 'Ændring af status på event (inkl. fjernelse)',
  },
  { key: 'event_details_changed', label: 'Eventinformationer ændres' },
  { key: 'event_reminder', label: 'Event-påmindelser' },
];

export function createDefaultNotificationPreferencesMatrix(): NotificationPreferencesMatrix {
  const matrix: NotificationPreferencesMatrix = {};
  for (const row of DUNA_EVENT_NOTIFICATION_PREFERENCE_ROWS) {
    matrix[row.key] = { email: true, push: true };
  }
  return matrix;
}

export function normalizeNotificationPreferencesMatrix(
  input: unknown
): NotificationPreferencesMatrix {
  const base = createDefaultNotificationPreferencesMatrix();
  if (!input || typeof input !== 'object') {
    return base;
  }
  const obj = input as Record<string, unknown>;
  for (const row of DUNA_EVENT_NOTIFICATION_PREFERENCE_ROWS) {
    const rowVal = obj[row.key];
    if (!rowVal || typeof rowVal !== 'object') {
      continue;
    }
    const channels = rowVal as Record<string, unknown>;
    base[row.key] = {
      email: channels['email'] !== false && channels['email'] !== 'false',
      push: channels['push'] !== false && channels['push'] !== 'false',
    };
  }
  return base;
}
